import { CurrencyCode, TriggerType } from './types';
import LiftReport from './LiftReport';

export interface IGoal {
  id: string;
  title: string;
  triggerType: TriggerType;
  liftReport?: LiftReport;
  cvValue?: number | null;
  cvValueCurrency?: CurrencyCode | null;
}

class Goal {
  public readonly id: string;
  public readonly title: string;
  public readonly triggerType: TriggerType;
  public readonly liftReport?: LiftReport;
  public readonly cvValue?: number | null;
  public readonly cvValueCurrency?: CurrencyCode | null;

  constructor({
    id,
    title,
    triggerType,
    liftReport,
    cvValue,
    cvValueCurrency,
  }: {
    id: string;
    title: string;
    triggerType: TriggerType;
    liftReport?: LiftReport;
    cvValue?: number | null;
    cvValueCurrency?: CurrencyCode | null;
  }) {
    this.id = id;
    this.title = title;
    this.triggerType = triggerType;
    this.liftReport = liftReport;
    this.cvValue = cvValue;
    this.cvValueCurrency = cvValueCurrency;
  }

  public toJSON = () => ({
    id: this.id,
    title: this.title,
    triggerType: this.triggerType,
    liftReport: this.liftReport,
    cvValue: this.cvValue,
    cvValueCurrency: this.cvValueCurrency,
  });

  public static fromJSON = (json: IGoal): Goal => {
    const { id, title, triggerType, liftReport, cvValue, cvValueCurrency } = Object.assign({}, json);

    if (typeof id !== 'string') throw new Error('.id must be a string');
    if (typeof title !== 'string') throw new Error('.title must be a string');
    if (typeof triggerType !== 'string') throw new Error('.triggerType must be a string');
    if (typeof cvValue !== 'number' && cvValue !== null) throw new Error('.cvValue must be a number');
    if (typeof cvValueCurrency !== 'string' && cvValueCurrency !== null)
      throw new Error('.cvValueCurrency must be a string');

    const _liftReport = liftReport ? LiftReport.fromJSON(liftReport) : undefined;

    return new Goal({
      id,
      title,
      triggerType,
      liftReport: _liftReport,
      cvValue,
      cvValueCurrency,
    });
  };
}

export default Goal;
